<template>
  <div id="Gallery">
    <TopCover />
    <List />
  </div>
</template>

<script>
import TopCover from "@/components/Gallery/TopCover/"
import List from "@/components/Gallery/List/"
export default {
  name: "Gallery",
  components: {
    TopCover,
    List
  },
  data() {
    return {}
  }
}
</script>